module.exports = __webpack_public_path__ + "static/img/14000308.b1a7002d.png";